<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <div class="row" @click="hideMenu">
    <div class="col-12">
      <div class="card">
        <div class="card-header" style="padding: 1%">
          <div class="card-title">
            <div class="card-tools">
              <form @submit.prevent>
                <div class="input-group input-group-sm" style="width: 150px">
                  <input
                    @keyup="buscarUsuarios"
                    type="text"
                    name="table_search"
                    v-model="filtro"
                    class="form-control float-right"
                    placeholder="Search"
                  />

                  <div class="input-group-append">
                    <button type="submit" class="btn btn-secondary" id="searchBtn" @click="buscarUsuarios(true)">
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="card-tools">
            <!-- PAGINAÇÃO  -->
            <ul class="pagination pagination-sm m-0 float-right">
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

              <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
                <a
                  :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'"
                  class="page-link"
                  href="#"
                  @click="selecionarPagina(pagina)"
                >
                  {{ pagina }}
                </a>
              </li>

              <li class="page-item">
                <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
              </li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
            </ul>
          </div>

          <div class="card-title">
            <div class="card-tools">
              <span style="margin-left: 15px">A tabela está ordenada por data de criação da pendência (crescente).</span>
            </div>
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body table-responsive p-0">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Seq</th>
                <th>ID</th>
                <th>Detalhes</th>
                <th>Endereço</th>
                <th>Contato</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(user, index) in users"
                :key="user.id"
                :style="getStyle(user)"
                :class="getClass(user)"
                @contextmenu.prevent="onRightClick($event, user)"
              >
                <td data-label="Seq">{{ index + 1 }}</td>
                <td data-label="Id">{{ user.user_id }}</td>
                <td data-label="Detalhes">
                  <strong>Apelido:</strong>
                  &nbsp;
                  <i class="fa-solid fa-circle" style="margin-right: 3px" :style="getStyleOnline(user)"></i>
                  <a style="text-transform: uppercase" :href="'/admin/cadastros/detalhes/' + user.user_id">{{ user.apelido }}</a>
                  <span
                    class="right badge badge-danger"
                    style="margin-left: 15px; background-color: blue"
                    v-if="user.cadastro_tipo == 'pf' && user.magistrado == 1"
                  >
                    PF-MAGISTRADO
                  </span>
                  <span class="right badge badge-danger" style="margin-left: 15px; background-color: #301904" v-else-if="user.cadastro_tipo == 'pj'">
                    PJ
                  </span>
                  <span class="right badge badge-danger" style="margin-left: 15px; background-color: blue" v-else-if="user.cadastro_tipo == 'pf'">
                    PF
                  </span>
                  <span
                    class="right badge"
                    style="margin-left: 3px; background-color: #9c362d; color: white"
                    v-if="user.telefone_celular_verificado == 0"
                  >
                    SMS NÃO VALIDADO
                  </span>
                  <span class="right badge" style="margin-left: 3px; background-color: #c24236; color: white" v-if="!user.email_verified_at">
                    E-MAIL NÃO VALIDADO
                  </span>
                  <br />

                  <strong>Nome:</strong>
                  &nbsp;
                  <a style="text-transform: uppercase">{{ user.nome_completo }}</a>
                  <br />
                  <strong>Estado civil:</strong>
                  &nbsp;
                  <a style="text-transform: uppercase">{{ user.estado_civil }}</a>
                  <br />
                  <strong>CPF:</strong>
                  &nbsp;
                  <a style="text-transform: uppercase">{{ user.cpf }}</a>
                  <span
                    @click="cadastro_selecionado = user"
                    data-toggle="modal"
                    data-target="#visualizar-cpfs"
                    class="right badge badge-danger"
                    style="cursor: pointer; margin-left: 15px; background-color: blue"
                    v-if="user.cpfs && user.cpfs.length > 0"
                  >
                    Existe
                  </span>
                  <br />
                  <strong>RG:</strong>
                  &nbsp;
                  <a style="text-transform: uppercase">{{ user.rg }}</a>
                  <br />
                  <br />
                  <strong>Data do cadastro:</strong>
                  &nbsp;
                  <span v-if="user.created_at">{{ formatDate(user.created_at) }} (há {{ calcularValor(user.created_at) }})</span>
                  <br />
                  <strong>
                    Documentos:
                    <span class="right badge badge-success" style="margin-left: 5px; background-color: blue">{{ user.documentos }}</span>
                  </strong>
                  <br />
                  <strong>Status:</strong>

                  <span class="right badge badge-success" style="margin-left: 5px" v-if="user.status == 'liberado'">LIBERADO</span>
                  <span class="right badge badge-danger" style="margin-left: 5px; background-color: #dbb50a" v-else-if="user.status == 'pendente'">
                    PENDENTE
                  </span>
                  <span class="right badge badge-danger" style="margin-left: 5px" v-else-if="user.status == 'bloqueado'">BLOQUEADO</span>
                  <span class="right badge badge-danger" style="text-transform: uppercase; margin-left: 5px; background-color: gray" v-else>
                    {{ user.status }}
                  </span>
                </td>
                <td data-label="Endereço">
                  <strong>Endereço:</strong>
                  &nbsp;
                  <a style="text-transform: uppercase">{{ user.endereco }}</a>
                  <br />
                  <strong>Número:</strong>
                  &nbsp;
                  <a style="text-transform: uppercase">{{ user.endereco_num }}</a>
                  <br />
                  <strong>Complemento:</strong>
                  &nbsp;
                  <a style="text-transform: uppercase">{{ user.endereco_complemento }}</a>
                  <br />
                  <strong>Bairro:</strong>
                  &nbsp;
                  <a style="text-transform: uppercase">{{ user.endereco_bairro }}</a>
                  <br />
                  <strong>CEP:</strong>
                  &nbsp;
                  <a style="text-transform: uppercase">{{ user.endereco_cep }}</a>
                  <br />
                  <strong>Cidade/UF:</strong>
                  &nbsp;
                  <a style="text-transform: uppercase" v-if="user.cidade && user.estado">{{ user.cidade + "/" + user.estado }}</a>
                  <br />
                </td>

                <td data-label="Contato">
                  <strong>E-mail:</strong>
                  &nbsp;{{ user.email }}
                  <br />
                  <strong>Fone:</strong>
                  &nbsp;{{ user.telefone_fixo }}
                  <br />
                  <strong>Celular:</strong>
                  &nbsp;{{ user.telefone_celular }}
                  <i v-if="user.telefone_celular_verificado === 1" class="fa-solid fa-check" style="margin-left: 7px; color: green"></i>
                  <span
                    @click="cadastro_selecionado = user"
                    data-toggle="modal"
                    data-target="#visualizar-celulares"
                    class="right badge badge-danger"
                    style="cursor: pointer; margin-left: 15px; background-color: blue"
                    v-if="user.celulares && user.celulares.length > 0"
                  >
                    Existe
                  </span>
                  <br />
                  <strong>IP de cadastro:</strong>
                  &nbsp;{{ user.cadastro_ip }}
                  <span
                    @click="cadastro_selecionado = user"
                    data-toggle="modal"
                    data-target="#visualizar-ips"
                    class="right badge badge-danger"
                    style="cursor: pointer; margin-left: 15px; background-color: blue"
                    v-if="user.ips && user.ips.length > 0"
                  >
                    Existe
                  </span>
                  <br />
                  <br />

                  <div
                    class="card"
                    style="width: 450px; max-width: 450px; background-color: rgb(219, 181, 10) !important"
                    v-if="user.pendencias.length"
                  >
                    <div class="card-body p-2">
                      <i class="fa-solid fa-circle-exclamation"></i>
                      <b>Possui pendências, verificar:</b>
                      <br />
                      <br />
                      <p v-for="(pendencia, index) in user.pendencias" :key="pendencia">
                        <span>Data: {{ formatDate(pendencia.created_at) }}</span>
                        <br />
                        <span v-html="pendencia.conteudo"></span>
                      </p>
                    </div>
                  </div>
                </td>

                <td data-label="Ações">
                  <a
                    id="navbarDropdown"
                    class="nav-link"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    v-pre
                  >
                    <i class="fa-solid fa-bars" style="color: gray"></i>
                  </a>

                  <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                    <div class="dropdown-divider"></div>
                    <a @click="getUrlDetalhes(user)" class="dropdown-item">
                      <i class="fa-solid fa-pen"></i>
                      &nbsp;&nbsp; Editar
                    </a>

                    <div class="dropdown-divider"></div>
                    <a :href="'/admin/cadastros/' + user.id + '/logs'" class="dropdown-item">
                      <i class="fa-solid fa-bars"></i>
                      &nbsp;&nbsp; Logs
                    </a>

                    <div class="dropdown-divider"></div>
                    <a style="cursor: pointer" @click="validarExcluirCadastro(user)" class="dropdown-item">
                      <i class="fa-solid fa-trash"></i>
                      &nbsp;&nbsp; Excluir
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            id="newMenu"
            style="visibility: hidden; position: absolute; background-color: white; max-width: 300px; line-height: 15px"
            class="dropdown-menu-lg dropdown-menu-right"
          >
            <div class="dropdown-divider"></div>
            <a @click="getUrlDetalhes(cadastro_selecionado)" class="dropdown-item">
              <i class="fa-solid fa-pen"></i>
              &nbsp;&nbsp; Editar
            </a>

            <div class="dropdown-divider"></div>
            <a :href="'/admin/cadastros/' + cadastro_selecionado.id + '/logs'" class="dropdown-item">
              <i class="fa-solid fa-bars"></i>
              &nbsp;&nbsp; Logs
            </a>

            <div class="dropdown-divider"></div>
            <a style="cursor: pointer" @click="validarExcluirCadastro(cadastro_selecionado)" class="dropdown-item">
              <i class="fa-solid fa-trash"></i>
              &nbsp;&nbsp; Excluir
            </a>
          </div>
        </div>
        <div class="card-footer clearfix">
          <!-- TOTAIS  -->
          <div style="font-size: 13px" class="float-left" aria-live="polite">
            Exibindo do {{ inicio + 1 }} ao {{ inicio + users.length }}
            <p>Total {{ total }}</p>
          </div>

          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
        <!-- /.card-body -->
      </div>
      <!-- /.card -->
    </div>
  </div>

  <!-- MODAL IPS -->
  <div class="modal fade" id="visualizar-ips" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="margin-top: 30px">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Ocorrências</h4>
            <br />
            <div class="card card-primary">
              <div class="card-body">
                <table class="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th>Seq</th>
                      <th>Apelido</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(usuario_online, index) in cadastro_selecionado.ips" :key="usuario_online">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.apelido }}</a>
                      </td>

                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.nome_completo }}</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="card-footer">
                <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- MODAL CELULARES -->
  <div
    class="modal fade"
    id="visualizar-celulares"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="margin-top: 30px"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Ocorrências</h4>
            <br />
            <div class="card card-primary">
              <div class="card-body">
                <table class="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th>Seq</th>
                      <th>Apelido</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(usuario_online, index) in cadastro_selecionado.celulares" :key="usuario_online">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.apelido }}</a>
                      </td>

                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.nome_completo }}</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="card-footer">
                <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- MODAL CPFS -->
  <div class="modal fade" id="visualizar-cpfs" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="margin-top: 30px">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Ocorrências</h4>
            <br />
            <div class="card card-primary">
              <div class="card-body">
                <table class="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th>Seq</th>
                      <th>Apelido</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(usuario_online, index) in cadastro_selecionado.cpfs" :key="usuario_online">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.apelido }}</a>
                      </td>

                      <td>
                        <a :href="'/admin/cadastros/detalhes/' + usuario_online.id">{{ usuario_online.nome_completo }}</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="card-footer">
                <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["docs_tipo_usuario", "action"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading },

  data() {
    return {
      isLoading: false,
      doc_tipo_usuario_selecionado: "",
      qtd_por_pagina: 25,
      pagina_atual: 1,
      inicio: 0,
      paginas: [],
      total: 0,
      users: [],
      filtro: "",
      cadastro_selecionado: "",
      max_page: 0,
    };
  },

  mounted() {
    this.buscarUsuarios();

    if (this.action) {
      this.action("Pendentes", this.total);
    }
  },

  methods: {
    validarExcluirCadastro(user) {
      console.log("V1");
      console.log(user);

      this.user_selecionado = user;

      let data = {
        id: user.id,
      };

      console.log("Validando");
      console.log(data);

      axios
        .post(`/admin/delete_user/validate`, data)
        .then((response) => {
          console.log("Resposta");
          console.log(response);

          if (response.data.success) {
            let html = "Deseja apagar o usuário com o e-mail " + user.email + " e com apelido " + user.apelido + " ? Essa ação é irreversível.";

            this.$swal
              .fire({
                title: "Confirmação",
                html: html,
                icon: "warning",
                padding: "1.5em",
                showCancelButton: true,
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim, quero deletar!",
              })
              .then((result) => {
                if (result.value) {
                  this.isLoading = true;

                  let data = {
                    id: user.user_id,
                    pergunta: html,
                  };

                  axios
                    .post(`/admin/delete_user/delete`, data)
                    .then((response) => {
                      this.isLoading = false;
                      this.showSuccessMessage("Usuário deletado com sucesso!");
                      this.buscarUsuarios();
                    })
                    .catch((error) => {
                      this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                      console.log(error.response.data);
                    });
                }
              });
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getClass(user) {
      if (user.status == "pendente") {
        return "table_todos_line";
      } else if (user.status == "liberado") {
        return "table_todos_line";
      } else if (user.status == "bloqueado") {
        return "table_todos_line";
      } else {
        return "";
      }
    },

    getStyle(user) {
      let style = "cursor:pointer;";

      if (user.status == "pendente") {
        return style + "background-color: #fcfdcd";
      } else if (user.status == "liberado") {
        return style + "background-color: #d6fbe4";
      } else if (user.status == "bloqueado") {
        return style + "background-color: #ffdbdb";
      } else {
        return style;
      }
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, cadastro) {
      this.cadastro_selecionado = cadastro;

      let newMenu = document.getElementById("newMenu");
      let x = event.clientX - 300;
      let y = event.pageY - 250;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 500 : x;

      console.log("X depois " + x);

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    getUrlDetalhes(user) {
      window.location.href = "/admin/cadastros/detalhes/" + user.user_id;
    },

    getStyleOnline(user) {
      let online = false;

      if (user.last_seen) {
        let dataReferencia = this.formatToCompare(new Date());
        let data = this.formatToCompare(user.last_seen);

        var duration = moment.duration(dataReferencia.diff(data));
        var min = duration.asMinutes();

        if (min <= 5) {
          online = true;
        }
      }

      if (online) {
        return "color: #007d41";
      } else {
        return "color: gray;";
      }
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();

        let tempo = " dias";
        if (days < 2) {
          tempo = " dia";
        }

        return ~~days + tempo;
      } else {
        let tempo = " horas";
        if (hours < 2) {
          tempo = " hora";
        }

        return ~~hours + tempo;
      }
    },

    formatToCompare(date) {
      return moment(date);
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    getUrlDocumentos(user) {
      return "/admin/user/document/" + user.id;
    },

    show(doc_tipo_usuario) {
      this.doc_tipo_usuario_selecionado = doc_tipo_usuario;
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarUsuarios();
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarUsuarios();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarUsuarios();
      }
    },

    buscarUsuarios(pagina_inicial) {
      this.isLoading = true;

      if (pagina_inicial) {
        this.pagina_atual = 1;
        this.inicio = 0;
      }

      let data = {
        search: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log("Buscando aguardando");
      console.log(data);

      axios
        .post(`/admin/fluxo_de_cadastros/pendentes`, data)
        .then((response) => {
          console.log("Usuarios");
          console.log(response.data.usuarios);
          this.isLoading = false;

          this.users = response.data.usuarios;
          this.total = response.data.total;

          if (this.action) {
            this.action("Falta validar SMS", this.total);
          }

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>
